{
	"choose-region": "Choose region",
	"postbox": "Parcel locker",
	"postbox-card": {
		"all-day": "24/7 all year round",
		"all-day-kringlan": "7:00-23:00 work days",
		"all-day-kringlan2": "11:00-23:00 on weekends",
		"open": "Open"
	},
	"postoffice": "Post office",
	"postoffice-card": {
		"email": "Email",
		"opening-hours": "Opening hours",
		"phone": "Phone"
	},
	"parcelpoint": "Parcel point",
	"seeAll": "See all",
	"search": "Search",
	"see-list": "See list",
	"see-map": "See map",
	"letter-postboxes": "Mailboxes"
}
